import { ReactElement, useEffect, useState } from 'react';
import { BeatLoader } from 'react-spinners';
import DropdownCustom from '../../controls/DropdownCustom';
import RawDataOverviewContainer from './OverviewContainer';
import Contor from '../contor';
import { useData } from '../../context/data.context';
import { Group, ParametersType } from '../../constants/telosair-interfaces';
import { getParameterByName } from '../../_helpers/globalHelper';

const DEFAULT_DROPDOWN_PLACEHOLDER_GROUP = 'Group';

type HeatMapProps = {
  onZoom: () => void;
  selectedParameters: ParametersType[];
};

/**
 * React component for HeatMap.
 * @param props - Properties of HeatMap component.
 * @returns - React component for HeatMap.
 */
export default function HeatMap(props: HeatMapProps): ReactElement {
  const { onZoom, selectedParameters } = props;
  const { groupedData, loading, parameters } = useData();
  const [selectedParameter, setSelectedParameter] = useState<ParametersType | null>(null);
  const [selectedGroup, setSelectedGroup] = useState<Group | null>(null);

  useEffect(() => {
    if (!loading && groupedData.length > 0) {
      setSelectedGroup(groupedData[0]);
    }
  }, [groupedData, loading]);

  /**
   * Handles changes in dropdown input values to select parameter.
   * @param selectedValue - The selected value of the parameter input change.
   */
  const handleOptionsSelectTemperature = (selectedValue: ParametersType): void => {
    // const isSelected = selectedParameters.includes(selectedValue);
    // if (isSelected) {
    //   setSelectedParameters((prev) => prev.filter((item) => item !== selectedValue));
    //   return;
    // }
    setSelectedParameter(selectedValue);
  };

  /**
   * Handles changes in dropdown input values to select group.
   * @param selectedValue - The selected value of the group input change.
   */
  const handleOptionsSelectGroup = (selectedValue: number): void => {
    const selectedGroupData = groupedData.find((item) => item.groupId === selectedValue);
    if (selectedGroupData) {
      setSelectedGroup(selectedGroupData);
    }
  };
  const DROPDOWN_PLACEHOLDER_PARAMETER = selectedParameter?.length
    ? getParameterByName(selectedParameter, parameters)?.shortName || 'Parameters'
    : 'Parameters';

  const DROPDOWN_PLACEHOLDER_GROUP = selectedGroup
    ? selectedGroup.groupName
    : DEFAULT_DROPDOWN_PLACEHOLDER_GROUP;

  const selectedParametersData = parameters
    .filter((item) => selectedParameters.includes(item.parameterName))
    .map((item) => ({
      name: item.shortName,
      id: item.parameterName
    }));

  useEffect(() => {
    if (!selectedParameter) {
      setSelectedParameter(selectedParameters[0]);
    }
  }, [selectedParameters, selectedParameter]);

  return (
    <RawDataOverviewContainer loading={loading} onZoom={onZoom} size="1/2" sectionName="Heatmap">
      {!loading ? (
        <>
          <div className="flex gap-3 mb-2">
            {/* <MultiCheckBoxDropDown<ParametersType>
              selectedItems={selectedParameters}
              onClick={handleOptionsSelectTemperature}
              controlPlaceholder={DROPDOWN_PLACEHOLDER_PARAMETER}
              buttons={parameters.map((item) => ({
                name: item.shortName,
                id: item.parameterName
              }))}
            /> */}
            <DropdownCustom<ParametersType>
              onClick={handleOptionsSelectTemperature}
              controlPlaceholder={DROPDOWN_PLACEHOLDER_PARAMETER}
              buttons={selectedParametersData}
            />
            <DropdownCustom<number>
              onClick={handleOptionsSelectGroup}
              controlPlaceholder={DROPDOWN_PLACEHOLDER_GROUP}
              buttons={groupedData.map((group) => ({ name: group.groupName, id: group.groupId }))}
            />
          </div>
          {selectedGroup && selectedParameter && (
            <Contor selectedParameters={[selectedParameter]} group={selectedGroup} />
          )}
        </>
      ) : (
        <div className="flex flex-1 justify-center items-center">
          <BeatLoader color="#36d7b7" />
        </div>
      )}
    </RawDataOverviewContainer>
  );
}
